import {
	GetBeneficiaryAddressValidationV4Params,
	GetBeneficiaryAddressValidationV4Response,
} from 'domain/usecases/private/profile/get-update-indicator';
import {makeGetUpdateIndicator} from 'main/factories/usecases/private/profile/get-update-indicator';

export async function getAddressUpdateIndicator({
	signal,
}: GetBeneficiaryAddressValidationV4Params): Promise<GetBeneficiaryAddressValidationV4Response> {
	return makeGetUpdateIndicator().get({signal});
}
